import React from 'react'

import { Listbox, ListboxOptionProps } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'

export interface IOption extends ListboxOptionProps<'div', any> {
  activeClassName?: string
}

const Option: React.FC<IOption> = ({
  children,
  className,
  activeClassName,
  ...props
}) => {
  return (
    <Listbox.Option
      className={({ active }) =>
        twMerge(
          'relative cursor-pointer select-none p-2 text-primary-900 dark:text-primary-100',
          active
            ? twMerge('bg-primary-100 dark:bg-primary-700', activeClassName)
            : '',
          typeof className === 'string' ? className : '',
        )
      }
      {...props}
    >
      {children}
    </Listbox.Option>
  )
}

export default Option
